import {ApplicationStoreType} from 'desktop/store';

import {CardType} from 'desktop/types/creditCardType';

import {MODULE_KEY_CHECKOUT} from '../constants';

/**
 * Return is payment method in loading state
 *
 * @param {ApplicationStoreType} state - store
 * @returns {boolean} isLoading
 */
export const getIsLoading = (state: ApplicationStoreType): boolean =>
    state[MODULE_KEY_CHECKOUT].paymentStep.creditCard.isLoading;

/**
 * Return user's saved cards
 *
 * @param {ApplicationStoreType} state - store
 * @returns {CardType[]} saved cards
 */
export const getSavedCards = (state: ApplicationStoreType): CardType[] =>
    state[MODULE_KEY_CHECKOUT].paymentStep.creditCard.cards;

/**
 * Return is saved card visible now
 *
 * @param {ApplicationStoreType} state - store
 * @returns {boolean} is saved card visible
 */
export const getShowSavedCards = (state: ApplicationStoreType): boolean =>
    state[MODULE_KEY_CHECKOUT].paymentStep.creditCard.showSavedCards;

/**
 * Return error message
 *
 * @param {ApplicationStoreType} state - store
 * @returns {string} error message
 */
export const getErrorMessage = (state: ApplicationStoreType): string =>
    state[MODULE_KEY_CHECKOUT].paymentStep.creditCard.error;
